const $ = jQuery;

export function getPosts(data, beforeCallback, afterCallback) {
    $.ajax({
        type: 'GET',
        url: menaObject.ajaxurl,
        dataType: 'html',
        data: data,
        beforeSend: beforeCallback,
        success: afterCallback,
        error: function (response) {
            console.error(response);
        },
    });
}
